import { Routes } from '@angular/router';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { authGuardToCheckUserLoggedInStatus } from './core/guards/auth.guard';
import { HomeComponent } from './features/user-artist/components/home/home.component';
import { checkRoleGuard } from './features/user-artist/userArtistGuard/checkUserRole/check-role.guard';
import { AuthCallbackComponent } from './components/auth-callback/auth-callback.component';

export const routes: Routes = [
  { path: '', pathMatch: "full", redirectTo: "gallery" },

  { path: 'privacy', loadComponent:() => import("./pages/privacy/privacy.component").then(c => c.PrivacyComponent) },
  { path: 'terms-and-conditions', loadComponent:() => import("./pages/termsandcondition/termsandcondition.component").then(c => c.TermsandconditionComponent) },
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.module').then((m) => m.AuthModule),
    canActivate: [authGuardToCheckUserLoggedInStatus],
  },
  {
    path: 'gallery',
    loadChildren: () =>
      import('./features/user-artist/user-artist.module').then(
        (m) => m.UserArtistModule
      ),
  },
 {
    path: 'artist',
    component: HomeComponent,
    children: [
      {
        path: ':id',
        loadComponent: () => import("./shared/components/artist-profile-card/profile-full-details/profile-full-details.component").then(c => c.ProfileFullDetailsComponent),
        canActivate: [checkRoleGuard],
        data: { role: ['AUDIENCE','GUEST','ARTIST'] },
      },
      {
        path: ':albumName/:albumId',
        loadComponent: () => import("./shared/components/user-select-arts/user-select-arts.component").then(c => c.UserSelectArtsComponent),
        canActivate: [checkRoleGuard],
        data: { role: ['AUDIENCE','GUEST','ARTIST'] },
      },
    ]
  },
  {
    path: 'buyframes/:userId',
    component: HomeComponent,
    children: [
      {
        path: ':userId',
        loadComponent:() => import("./features/user-artist/components/audience/buy-frame/buy-frame.component").then(c => c.BuyFramesComponent),
        canActivate: [checkRoleGuard],
        data: { role: ['AUDIENCE','GUEST','ARTIST'] },
      },
    ]
  },
  { path: 'payment_success', loadComponent:() => import("./pages/paymentScreen/payment-success/payment-success.component").then(c => c.PaymentSuccessComponent)},
  { path: 'payment_cancel', loadComponent:() => import("./pages/paymentScreen/payment-cancel/payment-cancel.component").then(c => c.PaymentCancelComponent)},
  { path: 'payment_pending', loadComponent:() => import("./pages/paymentScreen/payment-pending/payment-pending.component").then(c => c.PaymentPendingComponent)},
 { path: 'auth/callback', component: AuthCallbackComponent },
  // Wildcard route for a 404 page
  { path: '**', component: PageNotFoundComponent },
];
